import React from 'react'

const SnackBarContext = React.createContext({
  toggleSnackbar: (message: String, severity: String) => { },
})

export default SnackBarContext